<template>
	<div class="mall-box">
		<p class="title1">{{ infoData.title }} </p>
		<p class="title2" v-if="infoData && infoData.createTime">
			{{ dateFormatter(new Date(infoData.createTime), "yyyy-MM-dd hh:mm:ss") }}
		</p>
		<div class="info-box" v-loading="loading" >
			<div v-html="infoData.content"></div>
		</div>
		<p class="title3">
			{{ $t("news.moreTips") }}
		</p>
		<div class="type-box">
			<!-- <div
				:class="{ sel: pageParams.cateCode === 'system_notice' }"
				@click="typeChange('system_notice')">
				{{ $t("news.tabVal1") }}
			  </div> -->
			<div :class="{ sel: pageParams.cateCode === 'platform_notice' }" @click="typeChange('platform_notice')">
				{{ $t("news.tabVal2") }}
			</div>
			<div :class="{ sel: pageParams.cateCode === 'news' }" @click="typeChange('news')">
				{{ $t("news.tabVal3") }}
			</div>
			<div :class="{ sel: pageParams.cateCode === 'research-report' }" @click="typeChange('research-report')">
				{{ $t("news.tabVal4") }}
			</div>
		</div>
		<div class="news-list-box">
			<NewsNoData v-if="newsList.length <= 0" />
			<template v-for="(item, index) in newsList" v-else>
				<NewsItem :item="item" />
			</template>
		</div>
		<VFooter />
		<QuestionPopup />
	</div>
</template>

<script>
	import {
		mapState
	} from "vuex";
	import NewsItem from "./components/NewsItem";
	import NewsNoData from "./components/NewsNoData";
	import VFooter from "@/components/footer/VFooter";
	import QuestionPopup from "@/components/QuestionPopup/index";
	export default {
		components: {
			VFooter,
			NewsItem,
			NewsNoData,
			QuestionPopup,
		},
		data() {
			return {
				newsList: [],
				pageParams: {
					page: 0,
					rows: 3,
					cateCode: "platform_notice", // 焦点图：banner、新闻：news、系统通知：system_notice，平台公告：platform_notice、个人消息：personal_notice、常见问题：question
				},
				infoData: {
					title: ""
				},
				id: 0,
				loading: false,
			};
		},
		computed: {
			...mapState(["user", "errorCode"]),
		},
		mounted() {
			// this.infoData = JSON.parse(this.$route.query.info);
		},
		// 首次加载+参数变化都会触发
		watch: {
			$route: {
				// 监听路由变化（包括query/params）
				handler(newRoute, oldRoute) {
					console.log('参数变化了：', newRoute.query.id);
					this.id = newRoute.query.id;

					if (!this.id) {
						console.warn('id参数为空');
						this.infoData = {}; // 清空旧数据
						return;
					}

					// 调用参数变化后的业务逻辑
					this.getNewsDetail(this.id);
				},
				immediate: true, // 立即执行（首次加载也触发）
				deep: true // 深度监听（捕获query/params内部变化）
			}
		},
		methods: {
			typeChange(val) {
				this.pageParams.page = 1;
				this.pageParams.cateCode = val;
				this.getNewsList();
			},
			getNewsDetail(id) {
				this.loading = true; // 开启加载
				// 箭头函数中this指向组件，无需_this
				this.$axios.post("/cms/getDetail", {
						id
					}) // 直接传最新id
					.then((res) => {
						this.loading = false;
						if (res.data && res.data.code === this.errorCode.ok) {
							this.infoData = res.data.data; // 此时赋值才会更新最新数据
							console.log('数据更新成功：', this.infoData);
						} else {
							console.error('接口返回异常：', res.data);
							this.infoData = {}; // 清空旧数据
						}
					})
					.catch((err) => {
						this.loading = false;
						console.error('请求失败：', err);
						this.infoData = {}; // 异常时清空数据
					});
			},
			getNewsList() {
				const _this = this;
				this.$axios.post("/cms/getList", _this.pageParams).then((res) => {
					if (res.data.code === this.errorCode.ok) {
						_this.newsList = res.data.data.rows || [];
						_this.pageTotal = res.data.data.total || 0;
					}
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.mall-box {
		position: relative;
		background: #f5f6f7;

		.title1 {
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 36px;
			color: #333333;
			padding-top: 120px;
			text-align: center;
		}

		.title2 {
			text-align: center;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 20px;
			color: #999999;
		}

		.title3 {
			text-align: center;
			font-family: PingFang SC, PingFang SC;
			font-weight: 400;
			font-size: 36px;
			color: #333333;
		}

		.news-list-box {
			margin-top: 28px;
			margin-bottom: 160px;
			display: flex;
			gap: 28px;
			flex-wrap: wrap;
			padding: 0 260px;
			justify-content: center;
		}

		.type-box {
			gap: 20px;
			display: flex;
			margin-top: 20px;
			justify-content: center;

			div {
				// width: 104px;
				height: 40px;
				cursor: pointer;
				border-radius: 4px 4px 4px 4px;
				border: 1px solid #4063ff;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #4063ff;
				text-align: center;
				line-height: 40px;
				padding: 0 10px;
			}

			.sel {
				color: #ffffff;
				background: #4063ff;
			}
		}

		.info-box {
			padding: 40px 0;
			margin: 28px 260px 120px 260px;
			border-top: 1px solid #e2e3e3;
			border-bottom: 1px solid #e2e3e3;
		}
	}
</style>